var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-bform-group',_vm._b({attrs:{"label":_vm.requiredLabel(_vm.name)}},'nx-bform-group',_vm.$attrs,false),[_c('nx-bform-radio-group',{attrs:{"name":_vm.name,"rules":{ required: _vm.required },"options":[
      { text: _vm.$t('yes'), value: true },
      { text: _vm.$t('no'), value: false }
    ],"value":_vm.$attrs.value},on:{"input":_vm.$listeners.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }